// Lib
import React from 'react';
import classNames from 'classnames';

// Components
import ToolbarPopup from '../../toolbarPopup/ToolbarPopup';
import Icon from '../../../../../components/icons/Icon';
import Button from '../../../../../components/buttons/Button';

// Utils

// Constants
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';
import { TextAlignment, VerticalAlignment } from '../../../../../../common/table/CellTypeConstants';

import './TableCellAlignmentToolbarPopup.scss';

// FIXME - Remove these when we move completely over to the new table store architecture
import TableInstanceApiSingleton from '../../../../../element/table/manager/TableInstanceApiSingleton';
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';

type TableCellAlignmentToolbarPopupContentsProps = {
    commonTextAlignment: string;
    commonVerticalAlignment: string;

    // FIXME - Remove these when we move completely over to the new table store architecture
    element: object;
};

/**
 * NOTE: Structuring this as a separate component to avoid rendering the popup contents
 * when the popup isn't open.
 */
const TableCellAlignmentToolbarPopupContents: React.FC<TableCellAlignmentToolbarPopupProps> = ({
    commonTextAlignment,
    commonVerticalAlignment,
    element,
}) => {
    // FIXME - Remove these when we move completely over to the new table store architecture
    //  We want to avoid using the "tableOperationsRef" if possible
    const elementId = getElementId(element);
    const tableInstanceApi = TableInstanceApiSingleton.get(elementId);

    return (
        <>
            <ul className="cell-alignment-options">
                <li>
                    <Button
                        className={classNames('cell-alignment-options-button', {
                            active: commonTextAlignment === TextAlignment.LEFT,
                        })}
                        onClickFn={() =>
                            tableInstanceApi.tableOperationsRef.current.updateCellTextAlignment(TextAlignment.LEFT)()
                        }
                    >
                        <Icon name="toolbar-align-left" />
                    </Button>
                </li>
                <li>
                    <Button
                        className={classNames('cell-alignment-options-button', {
                            active: commonTextAlignment === TextAlignment.CENTER,
                        })}
                        onClickFn={() =>
                            tableInstanceApi.tableOperationsRef.current.updateCellTextAlignment(TextAlignment.CENTER)()
                        }
                    >
                        <Icon name="toolbar-align-center" />
                    </Button>
                </li>
                <li>
                    <Button
                        className={classNames('cell-alignment-options-button', {
                            active: commonTextAlignment === TextAlignment.RIGHT,
                        })}
                        onClickFn={() =>
                            tableInstanceApi.tableOperationsRef.current.updateCellTextAlignment(TextAlignment.RIGHT)()
                        }
                    >
                        <Icon name="toolbar-align-right" />
                    </Button>
                </li>
            </ul>

            <div className="divider" />

            <ul className="cell-alignment-options">
                <li>
                    <Button
                        className={classNames('cell-alignment-options-button', {
                            active: commonVerticalAlignment === VerticalAlignment.TOP,
                        })}
                        onClickFn={() =>
                            tableInstanceApi.tableOperationsRef.current.updateCellVerticalAlignment(
                                VerticalAlignment.TOP,
                            )()
                        }
                    >
                        <Icon name="toolbar-align-top" />
                    </Button>
                </li>
                <li>
                    <Button
                        className={classNames('cell-alignment-options-button', {
                            active: commonVerticalAlignment === VerticalAlignment.MIDDLE,
                        })}
                        onClickFn={() =>
                            tableInstanceApi.tableOperationsRef.current.updateCellVerticalAlignment(
                                VerticalAlignment.MIDDLE,
                            )()
                        }
                    >
                        <Icon name="toolbar-align-middle" />
                    </Button>
                </li>
                <li>
                    <Button
                        className={classNames('cell-alignment-options-button', {
                            active: commonVerticalAlignment === VerticalAlignment.BOTTOM,
                        })}
                        onClickFn={() =>
                            tableInstanceApi.tableOperationsRef.current.updateCellVerticalAlignment(
                                VerticalAlignment.BOTTOM,
                            )()
                        }
                    >
                        <Icon name="toolbar-align-bottom" />
                    </Button>
                </li>
            </ul>
        </>
    );
};

type TableCellAlignmentToolbarPopupProps = TableCellAlignmentToolbarPopupContentsProps & {
    buttonSelector: string;
    closePopup: () => void;
};

const TableCellAlignmentToolbarPopup: React.FC<TableCellAlignmentToolbarPopupProps> = ({
    commonTextAlignment,
    commonVerticalAlignment,
    element,
    buttonSelector,
    closePopup,
}) => (
    <ToolbarPopup
        closePopup={closePopup}
        buttonSelector={buttonSelector}
        showArrow
        popupId={PopupIds.TABLE_CELL_ALIGNMENT_TOOL}
        className="TableCellAlignmentToolbarPopup"
    >
        <TableCellAlignmentToolbarPopupContents
            commonTextAlignment={commonTextAlignment}
            commonVerticalAlignment={commonVerticalAlignment}
            element={element}
        />
    </ToolbarPopup>
);

export default TableCellAlignmentToolbarPopup;
